import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

export const ButtonWrapper = styled.div`
  padding: 1rem 0;
`;

export const Paragraph = styled.p<{
  marginBottom?: string;
}>`
  margin-bottom: 1.5rem;
  text-align: left;
  margin-top: -0.75rem;
  color: ${theme.color.text.secondary};
  ${theme.typography.bodyRegular}

  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom};
    `}
`;

export const WatchdogWrapper = styled.div`
  text-align: left;
`;

export const ErrorText = styled.span`
  margin-left: 1.2rem;
  line-height: 2.8125rem;
  color: ${theme.color.text.negative};
  cursor: help;
`;

export const Buttons = styled.div`
  margin-top: 1.25rem;
  max-height: 2.8125rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  button {
    width: 100%;
    @media (min-width: ${breakpoints.md}) {
      width: auto;
    }
  }
`;
